import { useTranslation } from '../i18n';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useTranslation();

  const toggle = () => {
    setLanguage(language === 'fr' ? 'en' : 'fr');
  };

  return (
    <button
      onClick={toggle}
      className="px-3 py-1.5 text-sm font-medium rounded-md transition-colors bg-white/10 hover:bg-white/20 text-white"
      aria-label={language === 'fr' ? 'Switch to English' : 'Passer en français'}
    >
      {language === 'fr' ? 'EN' : 'FR'}
    </button>
  );
}
